export default __webpack_public_path__ + "static/media/flag7.c50ebe82.jpg";